import { XIcon } from "lucide-react";

export default function TooltipContent({
  tooltipText,
}: {
  tooltipText: string;
}) {
  return (
    <div className="flex justify-between items-center">
      <span>{tooltipText}</span>
      <button
        className="ml-2 text-gray-500 hover:text-gray-700"
        onClick={(e) => {
          (e.target as HTMLElement).closest(".mapboxgl-popup")?.remove();
        }}
      >
        <XIcon className="w-4 h-4" />
      </button>
    </div>
  );
}
